
import $ from 'jquery';

let options = {
    toggle: {
        class: 'is-open'
    }
};

export default {
    init() {
        console.log('component/toggle.js:', $('body').attr('class'));

        bind_toggle();
    }
}

function bind_toggle() {
    let elements = $('[data-toggle]');

    elements.each((key, item) => {
        let element = $(item);
        let data = element.data();
        let group = data['toggleGroup'];
        let target = element;
        let underline = null;

        if (data['toggle']) {
            target = $.merge(target, $('[data-toggle-target*="' + data['toggle'] + '"'));
        }

        if (group) {
            underline = $('[data-toggle-underline*="' + group + '"]');
            group = $('[data-toggle-group*="' + group + '"]');
        }

        element.on('click', event => {
            if (group?.length) {
                group.removeClass(options.toggle.class);
            }

            if (underline?.length) {
                let bounds = element.get(0).getBoundingClientRect();

                underline.css({
                    left: bounds.left,
                    width: bounds.width
                });
            }

            if (element.hasClass(options.toggle.class)) {
                target.removeClass(options.toggle.class);
            } else {
                target.addClass(options.toggle.class);
            }
        });

        // set the initial state if "is-open" is detected
        if (group?.length) {
            element.hasClass(options.toggle.class) && element.trigger('click');
        }
    });
}